import type { ClientPortalData } from './types';

// Portal del Cliente — fuente de datos.
//
// MCP AI-First: los datos son del cliente logueado y se gatean por org +
// identidad en el BACKEND. El modelo de datos del despacho (expedientes,
// eventos procesales, bono de horas, adeudos, documentos) lo está construyendo
// Nabu (tickets KNP). Mientras ese endpoint no esté en prod, este módulo
// muestra el caso DEMO (el mismo que responde el agente Lex), para tener el
// portal navegable HOY.
//
// TODO(nabu): cuando exista, cambiar a:
//   const r = await fetch(`${API}/api/v1/clients-portal/me`, { headers: authHeaders() });
//   return r.json();
// Scoped por el JWT del cliente (org + su identidad) — cero cambios en la UI.

const DEMO: ClientPortalData = {
  clienteNombre: 'María González Ruiz',
  caso: {
    expediente: 'Juicio Ejecutivo Mercantil 452/2026',
    materia: 'Mercantil',
    juzgado: 'Juzgado Tercero de lo Civil de San Luis Potosí',
    estatus: 'En trámite · audiencia próxima',
    abogado: 'Lic. Roberto Ramírez',
    abogadoTelefono: '+524441121480',
    abogadoWhatsapp: '5214441748788',
    eventos: [
      { fecha: '05/ago/2026', tipo: 'Audiencia', detalle: 'Audiencia inicial programada, 10:00 h', urgente: true },
      { fecha: '20/jul/2026', tipo: 'Promoción', detalle: 'Ofrecimiento de pruebas' },
      { fecha: '28/jun/2026', tipo: 'Emplazamiento', detalle: 'Emplazamiento al demandado' },
      { fecha: '12/jun/2026', tipo: 'Demanda', detalle: 'Demanda presentada y admitida' },
    ],
  },
  bono: { plan: 'Innovación Legal 20h', contratadas: 20, usadas: 7.5, saldo: 12.5 },
  cuenta: { alCorriente: false, adeudo: 3500, concepto: 'Honorarios de julio', vencido: true },
  documentos: [
    { nombre: 'Demanda inicial.pdf', fecha: '12/jun/2026', tipo: 'Escrito' },
    { nombre: 'Contrato de servicios.pdf', fecha: '10/jun/2026', tipo: 'Contrato' },
    { nombre: 'Acuse de admisión.pdf', fecha: '14/jun/2026', tipo: 'Acuse' },
  ],
  isDemo: true,
};

export async function fetchClientPortal(): Promise<ClientPortalData> {
  return DEMO;
}
